import { ModelNormalize } from 'data';
import Position from './Position';

const NormalizePosition: ModelNormalize<Position> = {
  egress: position => position,
  ingress: position => position,
};

export default NormalizePosition;
